import React, { Component } from 'react';
import { Table } from 'antd';
import { queryFilePreview } from '@api/pub/attachment';

class TableFiles extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  columns = () => {
    return [
      {
        title: '文件名称',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: '附件',
        dataIndex: 'files',
        key: 'files',
        render: (text, record) => {
          return text
            ? text.map(item => {
                return (
                  <a
                    key={item.uuid}
                    style={{ display: 'block' }}
                    onClick={() => queryFilePreview(item)}
                  >
                    {item.name}
                  </a>
                );
              })
            : '';
        },
      },
    ];
  };

  render() {
    const { data, pagination, isLoading } = this.props;
    return (
      <Table
        rowKey="uuid"
        dataSource={data}
        loading={isLoading}
        pagination={pagination}
        columns={this.columns()}
        onChange={this.props.onChange}
      />
    );
  }
}

export default TableFiles;



// WEBPACK FOOTER //
// ./src/components/task/project/pageDetail/TableFiles.js